import React, { useCallback, useState } from 'react';

import MenuSectionDualHeading from 'components/menu-section-dual-heading';
import MenuSectionHeading from 'components/menu-section-heading';
import { useBrazeContext } from 'state/braze';

import { StyledContentCardContainer } from './styled';
import { IContentCardsProps } from './types';

const ContentCards: React.FC<IContentCardsProps> = ({ item: headersText }) => {
  const [displayed, setDisplayed] = useState(false);
  const { contentCardsHeader, contentCardsSubheader } = headersText ?? {};
  const heading = contentCardsHeader?.locale;
  const subheading = contentCardsSubheader?.locale;
  const braze = useBrazeContext();

  const containerRef = useCallback(
    (container: HTMLDivElement | null) => {
      if (!displayed && container) {
        braze.toggleContentCards(container);
        setDisplayed(true);
      }
    },
    [braze, displayed]
  );

  return (
    <>
      {displayed && heading && subheading && (
        <MenuSectionDualHeading heading={heading} subheading={subheading} />
      )}
      {displayed && heading && !subheading && <MenuSectionHeading>{heading}</MenuSectionHeading>}
      <StyledContentCardContainer ref={containerRef} />
    </>
  );
};

export default ContentCards;
